import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 8) { setError("Password must be at least 8 characters."); return; }
    setBusy(true);
    const res = await register(name, email, password);
    setBusy(false);
    if (res.ok) navigate("/dashboard", { replace: true });
    else setError(res.error);
  };

  return (
    <div className="min-h-[calc(100vh-64px)] grid grid-cols-1 lg:grid-cols-2" data-testid="register-page">
      <div className="flex items-center justify-center p-8 lg:p-16 order-2 lg:order-1">
        <form onSubmit={submit} className="w-full max-w-md space-y-6" data-testid="register-form">
          <div className="label-eyebrow">Enroll</div>
          <h2 className="font-serif text-4xl text-ink">Begin your 40 hours.</h2>
          <p className="text-sm text-muted-foreground">
            Create your trainee account. There is no payment in this preview — your account opens
            access to the full curriculum, assessments, and your eventual certificate.
          </p>
          {error && (
            <div className="bg-rust/10 border border-rust/40 text-rust px-4 py-3 text-sm" data-testid="register-error">
              {error}
            </div>
          )}
          <label className="block">
            <span className="label-eyebrow block mb-2">Full name</span>
            <input
              required value={name} onChange={(e) => setName(e.target.value)}
              className="w-full border border-stone bg-white px-4 py-3 focus:outline-none focus:border-ink"
              data-testid="register-name"
            />
          </label>
          <label className="block">
            <span className="label-eyebrow block mb-2">Email</span>
            <input
              type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-stone bg-white px-4 py-3 focus:outline-none focus:border-ink"
              data-testid="register-email"
            />
          </label>
          <label className="block">
            <span className="label-eyebrow block mb-2">Password (min 8 characters)</span>
            <input
              type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-stone bg-white px-4 py-3 focus:outline-none focus:border-ink"
              data-testid="register-password"
            />
          </label>
          <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="register-submit">
            {busy ? "Creating account…" : "Create account & begin"}
          </button>
          <div className="text-sm text-muted-foreground">
            Already enrolled? <Link to="/login" className="text-ink underline underline-offset-4" data-testid="register-to-login">Sign in</Link>
          </div>
        </form>
      </div>
      <div className="hidden lg:flex flex-col justify-between p-12 bg-terracotta text-bone order-1 lg:order-2">
        <div className="label-eyebrow text-bone/80">A clinical-grade training</div>
        <div>
          <h1 className="font-serif text-5xl leading-[1.05] mb-6">
            The work asks for everything. We prepare you for that.
          </h1>
          <p className="text-bone/90 max-w-[42ch] leading-relaxed">
            Twelve modules, written in service of the conversations that actually happen.
            Aligned to NC's 40-hour standard. Built for the field.
          </p>
        </div>
        <div className="label-eyebrow text-bone/70">Recovery happens in connection.</div>
      </div>
    </div>
  );
}
